import { render, staticRenderFns } from "./ItemInventoryForm.vue?vue&type=template&id=643b62cb&scoped=true"
import script from "./ItemInventoryForm.vue?vue&type=script&lang=js"
export * from "./ItemInventoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643b62cb",
  null
  
)

export default component.exports